import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campP9BudgetCappedNew: FaireAdCampaignEntity = {
  token: "camp_p9_budget_capped_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_p9_budget_capped",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 4000,
  startedRunningAt: "2024-09-17",
  segmentMetrics: {
    numCustomersAcquired: 363,
    salesDollars: 111681,
    totalAdsSpendDollars: 19481,
    cpaDollars: 54,
    bestEstimateSalesDollars: 111681,
    bestEstimateRoas: 5.73,
  },
  topCustomers: [
    {
      retailerName: "Prairie Rose Mercantile",
      storeType: "Boutique",
      location: "Tulsa, OK",
      totalOrders: 3,
      totalAmountDollars: 870,
      lastOrderedAt: "2026-06-25",
    },
    {
      retailerName: "Sunbelt Style Co.",
      storeType: "Apparel",
      location: "Phoenix, AZ",
      totalOrders: 2,
      totalAmountDollars: 540,
      lastOrderedAt: "2026-06-03",
    },
  ],
  performancePeriodTokens: [
    "perf_p9_budget_capped_new_202512",
    "perf_p9_budget_capped_new_202601",
    "perf_p9_budget_capped_new_202602",
    "perf_p9_budget_capped_new_202603",
    "perf_p9_budget_capped_new_202604",
    "perf_p9_budget_capped_new_202605",
    "perf_p9_budget_capped_new_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
